export default {
      id: "vote-grey-usage",
      viewBox: "0 0 150 150",
      url: __webpack_public_path__ + "img/icons.a12b6041.svg#vote-grey",
      toString: function () {
        return this.url;
      }
    }